import * as activities from './Activities';
import * as banks from './Banks';
import * as companies from './Companies';
import * as departmetSet from './DepartmentSet';
import * as department from './Department';
import * as provided from './ProvidedDepartments';
import * as membership from './Membership';
import * as ticketAssignee from './TicketAssignees';
import * as brands from './Brands';
import * as categoires from './Categories';

export const route = {
  path: 'preferences',
  children: [
    activities.route,
    banks.route,
    companies.route,
    departmetSet.route,
    department.route,
    provided.route,
    ticketAssignee.route,
    membership.route,
    brands.route,
    categoires.route,
  ],
};
